// import { Grid } from "@mui/material";
// import { BarChart, CreditCard, Description, LocalActivity, Person, Today, TrendingUp } from '@mui/icons-material';
// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
// import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
// import { useDispatch } from "react-redux";
// import { resetDataComponent } from "../../StateManagement/actions";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

// import { callAPI, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
// import { IRows } from "../../Components/Filter/WSFilterComponent";
// import StatsCard, { StatsCardProps } from "./subComponents/StatsCard";

// // Thermal print styles for 80mm paper
// const thermalPrintStyles = `
//   @page {
//     size: 80mm auto;
//     margin: 0;
//   }
//   @media print {
//     body {
//             font-family: Arial, sans-serif;
//             font-size: 14px;
//             margin: 0;
//             padding: 0;
//             line-height:2;
//           }

//            #thermal-receipt {
//             width: 80mm;
//             max-width: 80mm;
//             margin: auto;
//             padding: 4px;
//           }

//     .print-header {
//       text-align: center;
//       font-weight: bold;
//       font-size: 22px;
//       margin-bottom: 5px;
//     }
//     .print-shop {
//       text-align: center;
//       font-size: 14px;
//       font-weight: 600;
//       line-height:2;
//       margin-bottom: 10px;
//     }
//     .print-divider {
//       border-top: 1px dashed #000;
//       margin: 5px 0;
//     }
//     .print-row{
//   display:flex;
//   justify-content:space-between;
//   align-items:flex-start;
//   margin:2px 0;
// }
//     .print-row .customerName{
//     line-height:2;
//     }

//     .customer-line{
//   word-break: break-word;
//   white-space: normal;
// }

//     .print-row .phone{
//     line-height:2;
//     }

//     .print-footer {
//       text-align: center;
//       margin-top: 10px;
//       font-size: 9px;
//     }
//   }
// `;

// export const InvoiceList: React.FC<any> = React.memo((props) => {
//   const navigate = useNavigate();
//   const [selectedId, setSelectedId] = useState<string | number>(0);
//   const [isPopupOpen, setPopupOpen] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [stats, setStats] = useState({
//     totalSales: {} as StatsCardProps,
//     todaySales: {} as StatsCardProps,
//     monthlySales: {} as StatsCardProps,
//     totalInvoices: {} as StatsCardProps,
//   });

//   const dispatch = useDispatch();
//   const { showMessage } = useSnackbar();

//   const printRef = useRef<HTMLDivElement>(null);

//   const source = {
//     url: "Vyapar/SaleInvoice/search",
//     page: 1,
//     pageSize: 10,
//     filter: [],
//     sort: []
//   };

//   useEffect(() => {
//     updateMainHeader('Category');
//   })


//   async function getData() {
//     try {
//       setLoading(true)
//       const response: any = await callAPI(`Vyapar/SaleInvoice/dashboard-stats`, Method.GET);

//       console.log('dashboard ata', response);

//       if (response) {
//         setStats({
//           totalSales: response.totalSales,
//           todaySales: response.todaySales,
//           monthlySales: response.monthlySales,
//           totalInvoices: response.totalInvoices
//         });
//       }
//     } catch (error) {
//       console.error("failed to retrieve data", error);
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     getData();
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([
//     { 'Sale List': '/sale/list' },
//   ]);


//   const handleAction = (action: string, row: { customerName: string, id: number }) => {
//     console.log("Row data:", row);

//     if (action === "Edit") {
//       navigate(`/sale/${row.id}`);
//     } else if (action === "Delete") {
//       setSelectedId(row.id);
//       setPopupOpen(true);
//     } else if (action === "Print Invoice") {
//       handlePrint(row);
//     }
//   };


//   const handlePrint = (data: any) => {

//     const printWindow = window.open('', '_blank', 'width=800,height=600');

//     if (printWindow && printRef.current) {

//       const shopName = "RANGOLI COLLECTIONS";
//       const shopAddress = "Iritty Rd, Chavassery Near town bus stop, Kerala 670702";
//       const shopPhone = "+91 7594032123";

//       const invoiceDate = new Date(data.invoiceDate);

//       const receiptHTML = `
// <!DOCTYPE html>
// <html>
// <head>
// <title>Print Receipt</title>
// <style>${thermalPrintStyles}</style>
// </head>

// <body>
// <div id="thermal-receipt">

//   <div class="print-header">${shopName}</div>
//   <div class="print-shop">${shopAddress}</div>
//   <div class="print-shop">Ph: ${shopPhone}</div>

//   <div style="text-align:center;font-weight:bold;font-size:12px;margin-top:4px;">
//     SALES INVOICE
//   </div>

//   <div class="print-divider"></div>

//   <div class="print-row">
//   <span class="invoice">Invoice: ${data.invoiceNo}</span>

//   <span style="display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;">
//     <span>Date: ${invoiceDate.toLocaleDateString()}</span>
//     <span style="font-size:12px; margin-top:4px">Time: ${invoiceDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
//   </span>
// </div>

//   <div class="customer-line">
//   Customer: 
//   <span style="font-size:12px">${data.customerName || 'Walk-in'} </span>
// </div>

//   <div class="print-row">
//     <span>Phone: ${data.phoneNumber || 'N/A'}</span>
//   </div>

//   <div class="print-divider"></div>

//   <table style="width:100%;font-size:11px;">
//     <thead>
//       <tr>
//         <th style="text-align:left;">Item</th>
//         <th style="text-align:right;">Qty</th>
//         <th style="text-align:right;">Price</th>
//         <th style="text-align:right;">Total</th>
//       </tr>
//     </thead>

//     <tbody>
//       ${data.items.map((item: any) => `
//         <tr>
//           <td style="text-align:left;">${item.product.name.substring(0, 15)}</td>
//           <td style="text-align:right;">${item.quantity}</td>
//           <td style="text-align:right;">${item.pricePerUnit.toFixed(2)}</td>
//           <td style="text-align:right;">${item.amount.toFixed(2)}</td>
//         </tr>
//       `).join('')}
//     </tbody>
//   </table>

//   <div class="print-divider"></div>

//   <div class="print-row">
//     <span>Subtotal</span>
//     <span>₹ ${data.total.toFixed(2)}</span>
//   </div>

//   <div class="print-row">
//     <span>Discount</span>
//     <span>- ₹ ${0}</span>
//   </div>

//   <div class="print-row" style="font-weight:bold;font-size:14px; margin-top:3px;">
//     <span>TOTAL</span>
//     <span>₹ ${data.total.toFixed(2)}</span>
//   </div>

//   <div class="print-divider"></div>

//   <div class="print-row">
//     <span>Payment</span>
//     <span>${data.paymentType.toUpperCase()}</span>
//   </div>

//   <div class="print-footer">
//     Thank you for shopping! <br/>
//     Visit Again
//   </div>

// </div>
// </body>
// </html>
// `;

//       printWindow.document.write(receiptHTML);
//       printWindow.document.close();
//       printWindow.focus();

//       setTimeout(() => {
//         printWindow.print();
//         printWindow.onafterprint = () => {
//           printWindow.close();
//         };
//       }, 300);
//     }
//   };

//   const columns: IColumns[] = [
//     {
//       header: "Invoice No",
//       fieldName: "invoiceNo",
//       sortable: true,
//     },

//     {
//       header: "Invoice Date",
//       fieldName: "invoiceDate",
//       type: "date"
//     },

//     {
//       header: "Name",
//       fieldName: "customerName",
//       tooltip: true,
//       sortable: true,
//     },

//     {
//       header: "Phone",
//       fieldName: "phoneNumber",
//     },

//     {
//       header: "Total Amount",
//       fieldName: "total",
//       type: "amount",
//       sortable: true,
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Delete", "Print Invoice"],
//       actionCallback: handleAction,
//     },
//   ];

//   const filterRows: IRows[] = [
//     {
//       label: "Invoice#",
//       fieldName: "invoiceNo",
//       type: "text",
//       operator: "like",
//       rowDivision: 6
//     },
//     {
//       label: "Customer Name",
//       fieldName: "customerName",
//       type: "text",
//       operator: "like",
//       rowDivision: 6
//     },

//     {
//       label: "Phone Number",
//       fieldName: "phoneNumber",
//       type: "text",
//       operator: "like",
//       rowDivision: 6
//     },

//     {
//       label: "Enter Date",
//       fieldName: "CreatedAt",
//       type: "date",
//       operator: "gte",
//       rowDivision: 6
//     },

//   ];

//   const handleClick = () => {
//     navigate("/invoice");
//   };

//   return (
//     <Grid p={3}>
//       <Grid container spacing={2}>

//         <StatsCard
//           title="Total Sale Amount"
//           value={stats.totalSales.value}
//           trend={stats.totalSales.trend}
//           label={stats.totalSales.label}
//           subtitle={stats.totalSales.subtitle}
//           icon={<TrendingUp sx={{ fontSize: 28 }} />}
//           color={stats.totalSales.color}
//           loading={loading}
//           format="currency"
//         />

//         <StatsCard
//           title="Today Sale Amount"
//           value={stats.todaySales.value}
//           trend={stats.todaySales.trend}
//           label={stats.todaySales.label}
//           subtitle={stats.todaySales.subtitle}
//           icon={<Today sx={{ fontSize: 28 }} />}
//           color={stats.todaySales.color}
//           loading={loading}
//           format="currency"
//         />

//         <StatsCard
//           title="Total Invoice"
//           value={stats.totalInvoices.value}
//           trend={stats.totalInvoices.trend}
//           label={stats.totalInvoices.label}
//           subtitle={stats.totalInvoices.subtitle}
//           icon={<Description />}
//           color={stats.totalInvoices.color}
//           loading={loading}
//         />

//         <StatsCard
//           title="Current Month Sale"
//           value={stats.monthlySales.value}
//           trend={stats.monthlySales.trend}
//           label={stats.monthlySales.label}
//           subtitle={stats.monthlySales.subtitle}
//           icon={<BarChart sx={{ fontSize: 28 }} />}
//           color={stats.monthlySales.color}
//           loading={loading}
//           format="currency"
//         />

//         <Grid item xs={12}>
//           <WSDataGrid
//             id="saleGrid"
//             title="Sale"
//             columns={columns}
//             source={source}
//             filterFields={filterRows}
//             rowsPerPageCount={10}
//             searchBox={{ fieldName: 'name' }}
//             addButton={{ label: "Add New Sale", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             // clientSideSorting={true}
//             // clientSideSortingField="invoiceDate"
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>

//         <ConfirmationPopup
//           type="DELETE"
//           apiUrl="Vyapar/SaleInvoice"
//           id={selectedId}
//           confirmMessage="Are you sure you want to delete this sale invoice?"
//           open={isPopupOpen}
//           onClose={() => setPopupOpen(false)}
//           onConfirm={(data: any) => {
//             console.log("Delete response:", data);
//             dispatch(resetDataComponent("saleGrid"));
//             if (data.success === true) {
//               showMessage(data?.message, "success");
//             } else {
//               showMessage(data?.message, "error");
//             }
//           }}
//         />


//         <div ref={printRef} style={{ display: 'none' }} />

//         {/* <WSLoadingOverlay
//                     loading={loading}
//                     message="Fetching Data..."
//                 /> */}
//       </Grid>
//     </Grid>
//   );
// });



import { Grid } from "@mui/material";
import { BarChart, CreditCard, Description, LocalActivity, Person, Today, TrendingUp } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

import { callAPI, getValue, LoacalVariables, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import StatsCard, { StatsCardProps } from "./subComponents/StatsCard";
import { useNavigate, useParams } from "react-router-dom";

// Thermal print styles for 80mm paper
const thermalPrintStyles = `
  @page {
    size: 80mm auto;
    margin: 0;
  }
  @media print {
    body {
            font-family: Arial, sans-serif;
            font-size: 14px;
            margin: 0;
            padding: 0;
            line-height:2;
          }

           #thermal-receipt {
            width: 80mm;
            max-width: 80mm;
            margin: auto;
            padding: 4px;
          }
    
    .print-header {
      text-align: center;
      font-weight: bold;
      font-size: 22px;
      margin-bottom: 5px;
    }
    .print-shop {
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height:2;
      margin-bottom: 10px;
    }
    .print-divider {
      border-top: 1px dashed #000;
      margin: 5px 0;
    }
    .print-row{
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  margin:2px 0;
}
    .print-row .customerName{
    line-height:2;
    }

    .customer-line{
  word-break: break-word;
  white-space: normal;
}

    .print-row .phone{
    line-height:2;
    }

    .print-footer {
      text-align: center;
      margin-top: 10px;
      font-size: 9px;
    }
  }
`;

interface Item {
  id?: number;
  product: { id: number; name: string };
  quantity: number;
  pricePerUnit: number;
  amount: number;
}

interface Invoice {
  id: number;
  invoiceNo: string;
  invoiceDate: string;
  customerName: string;
  phoneNumber: string;
  total: number;
  paymentType: "cash" | "card" | "upi" | "bank_transfer";
  items: Item[];
}


export const InvoiceList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState<Invoice | null>(null);
  const [editInvoice, setEditInvoice] = useState<Invoice>({
    id: 0,
    invoiceNo: "",
    invoiceDate: new Date().toISOString().split("T")[0],
    customerName: "",
    phoneNumber: "",
    total: 0,
    paymentType: "cash" as const,
    items: [{ product: { id: 0, name: "" }, quantity: 1, pricePerUnit: 0, amount: 0 }],
  });
  const [products, setProducts] = useState<{ id: number; name: string }[]>([]);


  const [stats, setStats] = useState({
    totalSales: {} as StatsCardProps,
    todaySales: {} as StatsCardProps,
    monthlySales: {} as StatsCardProps,
    totalInvoices: {} as StatsCardProps,
  });

  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const printRef = useRef<HTMLDivElement>(null);

  const source = {
    url: "Vyapar/SaleInvoice/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  useEffect(() => {
    updateMainHeader('Category');
  })


  async function getData() {
    try {
      setLoading(true)
      const response: any = await callAPI(`Vyapar/SaleInvoice/dashboard-stats`, Method.GET);

      if (response) {
        setStats({
          totalSales: response.totalSales,
          todaySales: response.todaySales,
          monthlySales: response.monthlySales,
          totalInvoices: response.totalInvoices
        });
      }
    } catch (error) {
      console.error("failed to retrieve data", error);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    updateMainHeader('Sale Invoice');
    if (id) {
      setEditMode(true);
      fetchInvoice(parseInt(id));
    } else {
      getData();
    }
  }, [id]);

  const fetchInvoice = async (invoiceId: number) => {
    try {
      setLoading(true);
      const response: any = await callAPI(`Vyapar/SaleInvoice/${invoiceId}`, Method.GET);
      if (response) {
        setCurrentInvoice(response);
        setEditInvoice(response);
        // Fetch products if needed
        const productsResponse: any = await callAPI(`Vyapar/Product/search`, Method.GET);
        setProducts(productsResponse || []);
      }
    } catch (error) {
      showMessage("Failed to fetch invoice", "error");
      console.error("Fetch invoice error:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateInvoiceTotal = () => {
    const total = editInvoice.items.reduce((sum: number, item: Item) => sum + item.amount, 0);
    setEditInvoice({ ...editInvoice, total });
  };

  const handleEditInputChange = (field: keyof Invoice, value: any) => {
    setEditInvoice({ ...editInvoice, [field]: value });
  };

  const handleEditItemChange = (index: number, field: keyof Omit<Item, 'id'>, value: any) => {
    const newItems = [...editInvoice.items];
    if (field === "product") {
      newItems[index] = { ...newItems[index], product: value, pricePerUnit: 100 };
    } else if (field === "quantity" || field === "pricePerUnit") {
      newItems[index] = { ...newItems[index], [field]: value };
      newItems[index].amount = (newItems[index].quantity as number) * (newItems[index].pricePerUnit as number);
    } else {
      newItems[index] = { ...newItems[index], [field]: value };
    }
    setEditInvoice({ ...editInvoice, items: newItems });
    setTimeout(updateInvoiceTotal, 0);
  };

  const removeEditItem = (index: number) => {
    const newItems = editInvoice.items.filter((_: Item, i: number) => i !== index);
    setEditInvoice({ ...editInvoice, items: newItems });
    setTimeout(updateInvoiceTotal, 0);
  };


  const handleSaveEdit = async () => {
    try {
      setLoading(true);
      const response: any = await callAPI(
        `Vyapar/SaleInvoice/${editInvoice.id}`,
        Method.PUT,
        editInvoice
      );

      if (response.success) {
        showMessage("Invoice updated successfully!", "success");
        setEditMode(false);
        getData();
        dispatch(resetDataComponent("saleGrid"));
      } else {
        showMessage(response?.message || "Update failed", "error");
      }
    } catch (error) {
      showMessage("Failed to update invoice", "error");
      console.error("Update error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteEdit = async () => {
    try {
      const response: any = await callAPI(
        `Vyapar/SaleInvoice/${editInvoice.id}`,
        Method.DELETE
      );
      if (response.success) {
        showMessage("Invoice deleted successfully!", "success");
        setEditMode(false);
        navigate("/sale/list");
      }
    } catch (error) {
      showMessage("Failed to delete invoice", "error");
    }
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setCurrentInvoice(null);
    navigate("/sale/list");
  };

  breadCrumbsStore.updateBreadCrumbs([
    { 'Sale List': '/sale/list' },
  ]);


  const handleAction = (action: string, row: { customerName: string, id: number }) => {

    if (action === "Edit") {
      navigate(`/invoice/${row.id}`);
    } else if (action === "Delete") {
      setSelectedId(row.id);
      setPopupOpen(true);
    } else if (action === "Print Invoice") {
      handlePrint(row);
    }
  };

  const handlePrint = (data: any) => {

    const printWindow = window.open('', '_blank', 'width=800,height=600');

    if (printWindow && printRef.current) {
      const invoiceDate = new Date(data.invoiceDate);

      const shopName = getValue(LoacalVariables.BusinessName);
      const shopAddress = getValue(LoacalVariables.BusinessAddress);
      const shopPhone = getValue(LoacalVariables.BusinessPhoneNumber);

      const receiptHTML = `
<!DOCTYPE html>
<html>
<head>
<title>Print Receipt</title>
<style>${thermalPrintStyles}</style>
</head>

<body>
<div id="thermal-receipt">

  <div class="print-header">${shopName}</div>
  <div class="print-shop">${shopAddress}</div>
  <div class="print-shop">Ph: ${shopPhone}</div>

  <div style="text-align:center;font-weight:bold;font-size:12px;margin-top:4px;">
    SALES INVOICE
  </div>

  <div class="print-divider"></div>

  <div class="print-row">
  <span class="invoice">Invoice: ${data.invoiceNo}</span>

  <span style="display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;">
    <span>Date: ${invoiceDate.toLocaleDateString()}</span>
    <span style="font-size:12px; margin-top:4px">Time: ${invoiceDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
  </span>
</div>

  <div class="customer-line">
  Customer: 
  <span style="font-size:12px">${data.customerName || 'Walk-in'} </span>
</div>

  <div class="print-row">
    <span>Phone: ${data.phoneNumber || 'N/A'}</span>
  </div>

  <div class="print-divider"></div>

  <table style="width:100%;font-size:11px;">
    <thead>
      <tr>
        <th style="text-align:left;">Item</th>
        <th style="text-align:right;">Qty</th>
        <th style="text-align:right;">Price</th>
        <th style="text-align:right;">Total</th>
      </tr>
    </thead>

    <tbody>
      ${data.items.map((item: any) => `
        <tr>
          <td style="text-align:left;">${item.product.name.substring(0, 15)}</td>
          <td style="text-align:right;">${item.quantity}</td>
          <td style="text-align:right;">${item.pricePerUnit.toFixed(2)}</td>
          <td style="text-align:right;">${item.amount.toFixed(2)}</td>
        </tr>
      `).join('')}
    </tbody>
  </table>

  <div class="print-divider"></div>

  <div class="print-row">
    <span>Subtotal</span>
    <span>₹ ${data.total.toFixed(2)}</span>
  </div>

  <div class="print-row">
    <span>Discount</span>
    <span>- ₹ ${0}</span>
  </div>

  <div class="print-row" style="font-weight:bold;font-size:14px; margin-top:3px;">
    <span>TOTAL</span>
    <span>₹ ${data.total.toFixed(2)}</span>
  </div>

  <div class="print-divider"></div>

  <div class="print-row">
    <span>Payment</span>
    <span>${data.paymentType.toUpperCase()}</span>
  </div>

  <div class="print-footer">
    Thank you for shopping! <br/>
    Visit Again
  </div>

</div>
</body>
</html>
`;

      printWindow.document.write(receiptHTML);
      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.onafterprint = () => {
          printWindow.close();
        };
      }, 300);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Invoice No",
      fieldName: "invoiceNo",
      sortable: true,
    },

    {
      header: "Invoice Date",
      fieldName: "invoiceDate",
      type: "date"
    },

    {
      header: "Name",
      fieldName: "customerName",
      tooltip: true,
      sortable: true,
    },

    {
      header: "Phone",
      fieldName: "phoneNumber",
    },

    {
      header: "Total Amount",
      fieldName: "total",
      type: "amount",
      sortable: true,
    },
    {
      header: "Status",
      fieldName: "status",
      type: "status"
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete", "convert to submitted", "Print Invoice"],
      actionCallback: handleAction,
    },
  ];

  const filterRows: IRows[] = [
    {
      label: "Invoice#",
      fieldName: "invoiceNo",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Customer Name",
      fieldName: "customerName",
      type: "text",
      operator: "like",
      rowDivision: 6
    },

    {
      label: "Phone Number",
      fieldName: "phoneNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },

    {
      label: "Enter Date",
      fieldName: "CreatedAt",
      type: "date",
      operator: "gte",
      rowDivision: 6
    },

  ];

  const handleClick = () => {
    navigate("/invoice");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>

        <StatsCard
          title="Total Sale Amount"
          value={stats.totalSales.value}
          trend={stats.totalSales.trend}
          label={stats.totalSales.label}
          subtitle={stats.totalSales.subtitle}
          icon={<TrendingUp sx={{ fontSize: 28 }} />}
          color={stats.totalSales.color}
          loading={loading}
          format="currency"
        />

        <StatsCard
          title="Today Sale Amount"
          value={stats.todaySales.value}
          trend={stats.todaySales.trend}
          label={stats.todaySales.label}
          subtitle={stats.todaySales.subtitle}
          icon={<Today sx={{ fontSize: 28 }} />}
          color={stats.todaySales.color}
          loading={loading}
          format="currency"
        />

        <StatsCard
          title="Total Invoice"
          value={stats.totalInvoices.value}
          trend={stats.totalInvoices.trend}
          label={stats.totalInvoices.label}
          subtitle={stats.totalInvoices.subtitle}
          icon={<Description />}
          color={stats.totalInvoices.color}
          loading={loading}
        />

        <StatsCard
          title="Current Month Sale"
          value={stats.monthlySales.value}
          trend={stats.monthlySales.trend}
          label={stats.monthlySales.label}
          subtitle={stats.monthlySales.subtitle}
          icon={<BarChart sx={{ fontSize: 28 }} />}
          color={stats.monthlySales.color}
          loading={loading}
          format="currency"
        />

        <Grid item xs={12}>
          <WSDataGrid
            id="saleGrid"
            title="Sale"
            columns={columns}
            source={source}
            filterFields={filterRows}
            rowsPerPageCount={10}
            searchBox={{ fieldName: 'name' }}
            addButton={{ label: "Add New Sale", color: "secondary" }}
            onAddButtonClick={handleClick}
            // clientSideSorting={true}
            // clientSideSortingField="invoiceDate"
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>

        <ConfirmationPopup
          type="DELETE"
          apiUrl="Vyapar/SaleInvoice"
          id={selectedId}
          confirmMessage="Are you sure you want to delete this sale invoice?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("saleGrid"));
            getData();
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.message, "error");
            }
          }}
        />

        <div ref={printRef} style={{ display: 'none' }} />
      </Grid>
    </Grid>
  );
});

